export const searchFormOption = function () {
  return [
    {
      prop: "keyword",
      label: "关键字",
      type: "input",
      placeholder: "请输入名称/联系电话/证件号",
    },
  ];
};

// 新增车辆option
export const personFormOption = function () {
  return [
    {
      prop: "upload",
      label: "身份证扫描",
      slotName: "uploadBtn",
    },
    {
      prop: "type",
      label: "身份类型",
      type: "radio",
      options: [
        {
          label: "个人",
          value: 0,
        },
        {
          label: "团队",
          value: 1,
        },
      ],
    },
    {
      prop: "personName",
      label: "姓名",
      type: "input",
      placeholder: "请输入姓名",
      minWidth: 150,
    },
    {
      prop: "certNo",
      label: "证件号",
      type: "input",
      placeholder: "请输入证件号",
      privacyType: true,
    },
    {
      prop: "tel",
      label: "电话",
      type: "input",
      placeholder: "请输入电话号",
      privacyType: true,
    },
    {
      prop: "addr",
      label: "地址",
      type: "input",
      placeholder: "请输入地址",
    },
    {
      prop: "email",
      label: "邮箱",
      type: "input",
      placeholder: "请输入邮箱",
    },
  ];
};
export default {};
